module.exports = __webpack_public_path__ + "img/swkitnumbers@2x.c167b2e4.png";